<template></template>
<script>
  import 'jquery-validation'
  import autosize from 'autosize'
  import 'flatpickr'
  import 'flatpickr/dist/flatpickr.min.css'
  import { Spanish } from 'flatpickr/dist/l10n/es'
  import moment from 'moment'
  
  export default {
    name: 'RegisterProtocol',
    data () {
      return {
        protocol: null,
      }
    },
    mounted () {
      const $startDate = $('#start_date')
      const $endDate   = $('#end_date')
      
      if (window.protocol) {
        this.protocol = window.protocol
      }
      
      autosize($('textarea'))
      
      /**
       * Apply date pickers.
       **/
      const vm = this
      
      $startDate.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
        onChange (dates, dateStr, instance) {
          const date = moment(dates[0]).add(1, 'd').format('DD/MM/YYYY')
          vm.endDate.set('minDate', date)
        },
      })
      
      $endDate.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
      })
      
      this.starDate = $startDate.get(0)._flatpickr
      this.endDate  = $endDate.get(0)._flatpickr
      
      /**
       * Tooltips.
       **/
      const tooltips = {
        '1': 'Es aquella relativa al estudio de los mecanismos celulares, moleculares,genéticos, bioquímicos, inmunológicos y otros, que tenga como propósito ampliar el conocimiento de la ciencia médica',
        '2': 'Se orienta a la comprensión, prevención, diagnóstico, tratamiento y rehabilitación con procedimientos quirúrgicos de problemas de salud determinados.',
        '3': 'Se orienta a la comprensión, prevención, diagnóstico, tratamiento y rehabilitación de problemas de salud determinados.',
        '4': 'Aquella que permite el conocimiento de los vínculos entre las causas de enfermedad, la práctica médica y la estructura social; así como la organización de los servicios de salud.',
        '5': 'Se orienta a la aplicación del conocimiento científico, para la solución de problemas prácticos; basado en un conocimiento desarrollado para proveer bienes y servicios para la mejora de las condiciones de salud.',
      }
      
      $('#study_type_id').on('change', function () {
        const studyType     = $(this).val()
        const $researchType = $('#research_type_id')
        
        $researchType.attr('title', '')
          .attr('data-original-title', '')
          .tooltip('dispose')
        
        // Estudio clínico.
        if (parseInt(studyType) === 4) {
          $researchType.val(3) // Clínica
            .find('option:not(:selected)')
            .prop('disabled', true)
          
          $researchType.attr('title', tooltips['3'])
            .attr('data-original-title', tooltips['3'])
            .tooltip('show')
        }
        else {
          $researchType.val('') // Clínica
            .find('option:not(:selected)')
            .prop('disabled', false)
        }
      })
      
      $('#research_type_id').on('change', function () {
        const tooltip = tooltips[$(this).val()]
        
        if (tooltip) {
          $(this).attr('title', tooltip)
            .attr('data-original-title', tooltip)
            .tooltip('show')
        }
        else {
          $(this).attr('title', '')
            .attr('data-original-title', '')
            .tooltip('dispose')
        }
      })
      
      /**
       * Show collapsed inputs
       */
      showInputs()
      
      $(window).on('pageshow', function () {
        showInputs()
      })
      
      function showInputs () {
        $('.show-collapse:checked').each(function (key, input) {
          let target = $($(this).attr('data-target').replace(':not(.show)', ''))
          target.addClass('show')
        })
      }
      
      /**
       * Init Select2
       */
      const $search = $('.search-select-multiple-institutions')
      
      $search.select2({
        placeholder: 'Selecciones instituciones',
        tokenSeparators: [','],
        language: {
          noResults: function () {
            return 'No se encontraron instituciones disponibles.'
          },
        },
      })
      
      const $searchKeywords = $('.search-select-multiple-keywords')
      
      $searchKeywords.select2({
        placeholder: 'Ingrese palabras clave',
        tokenSeparators: [','],
        tags: true,
        language: {
          noResults: function () {
            return 'Escriba la palabra y presione Enter para agregarla'
          },




        },
      })
      
      /**
       * Init JQuery validation
       */
      $(() => {
        $.validator.addMethod('after', function (value, element, param) {
          const start = moment($(param).val(), 'DD/MM/YYYY').format('YYYY-MM-DD')
          const end   = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
          
          return $(param).val() !== '' && value !== '' && moment(end).isAfter(start)
        }, 'La fecha de término debe ser posterior a la fecha de inicio.')
        
        $('.form').validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            if (element.hasClass('search-select-multiple-keywords') || element.hasClass('search-select-multiple-institutions')) {
              label.insertAfter(element.siblings('span.select2'))
            }
            else {
              label.insertAfter(element)
            }
            
            label.addClass('invalid-feedback')
          },
          rules: {
            title: {
              required: true,
            },
            study_type_id: {
              required: true,
            },
            research_type_id: {
              required: true,
            },
            summary: {
              required: true,
            },
            'keywords[]': {
              required: true,
            },
            start_date: {
              required: true,
            },
            end_date: {
              required: true,
              after: '#start_date',
            },
            overall_objective: {
              required: true,
            },
            specific_objective: {
              required: true,
            },
            in_collaboration: {
              required: true,
            },
            'institutions[]': {
              required: function () {
                return $('[name="in_collaboration"]:checked').val() !== ''
              },
            },
          },
          messages: {
            title: {
              required: 'Este campo es requerido.',
            },
            summary: {
              required: 'Este campo es requerido.',
            },
            'keywords[]': {
              required: 'Este campo es requerido.',
            },
            start_date: {
              required: 'Este campo es requerido.',
            },
            end_date: {
              required: 'Este campo es requerido.',
            },
            overall_objective: {
              required: 'Este campo es requerido.',
            },
            specific_objective: {
              required: 'Este campo es requerido.',
            },
            study_type_id: {
              required: 'Este campo es requerido.',
            },
            research_type_id: {
              required: 'Este campo es requerido.',
            },
            in_collaboration: {
              required: 'Este campo es requerido.',
            },
            'institutions[]': {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler (form) {
            $('#btn-save .spinner-border').removeClass('d-none')
            $('#btn-save').prop('disabled', true)
            $('#btn-cancel').addClass('disabled')
  
            form.submit()
          },
        })
        
        $('#protocol-form').removeClass('invisible')
        
        $('#btn-cancel').on('click', (e) => {
          e.preventDefault()
          
          history.back()
        })
      })
    },
  }
</script>
